"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ICP_MAYBE_MATCH = exports.ICP_TOP_FIT_MATCH = exports.ICP_EVENTS = exports.answerIcpQuestionSchema = exports.ICP_EMPTY_ANSWER = exports.ICP_UNFAIR_ANSWER = exports.startIcpInterviewSchema = exports.setIcpRatingsSchema = exports.saveIcpSchema = exports.icpItemInputSchema = exports.icpFactSchema = exports.icpRatingSchema = exports.SONNET_MICRO_USD_PER_THOUSAND_CACHE_WRITE = exports.SONNET_MICRO_USD_PER_THOUSAND_CACHE_READ = exports.SONNET_MICRO_USD_PER_THOUSAND_OUTPUT = exports.SONNET_MICRO_USD_PER_THOUSAND_INPUT = exports.JEV_TOKENS_PER_PART_ESTIMATE = exports.JEV_TOKENS_PER_CV_ESTIMATE = exports.ICP_RATINGS_SAVE_DELAY_MS = exports.ICP_ENGLISH_MEETS_AT = exports.ICP_NOTICE_NEAR_FACTOR = exports.ICP_YEARS_OVER_CREDIT = exports.ICP_YEARS_NEAR = exports.ICP_SALARY_NEAR_PERCENT = exports.ICP_ANSWER_MAX = exports.ICP_OPTION_MAX = exports.ICP_OPTIONS_MAX = exports.ICP_QUESTION_MAX = exports.ICP_MORE_QUESTIONS_MAX = exports.ICP_QUESTIONS_MAX = exports.ICP_NOTICE_DAYS_MAX = exports.ICP_YEARS_STEP = exports.ICP_YEARS_MAX = exports.ICP_ALIASES_MAX = exports.ICP_CITY_MAX = exports.ICP_EVIDENCE_MAX = exports.ICP_TEXT_MAX = exports.ICP_ITEMS_MAX = exports.ICP_FACT_TYPE_LABELS = exports.ICP_FACT_TYPES = exports.ICP_ENGLISH_MAX = exports.ICP_JEV_ITEMS_MAX = exports.ICP_SOURCE_LABELS = exports.ICP_SOURCES = exports.ICP_RATING_LABELS = exports.ICP_MUST_RATING = exports.ICP_RATINGS = exports.ICP_GROUP_HOW = exports.ICP_GROUP_LABELS = exports.ICP_GROUPS = void 0;
exports.PROFILE_RANKING_EVENTS = exports.icpConfigProfileSchema = exports.setJevAutoBudgetSchema = exports.raiseRankingMigrationBudgetSchema = exports.RANKING_MIGRATION_STATUSES = exports.ICP_READ_STATES = exports.RANKING_MIGRATION_RETRY_DELAY_MS = exports.RANKING_MIGRATION_RETRIES_MAX = exports.RANKING_MIGRATION_JOBS_AT_ONCE = exports.RANKING_MIGRATION_BUDGET_DEFAULT_MICRO_USD = exports.JEV_AUTO_BUDGET_DEFAULT_MICRO_USD = exports.RANKING_MIGRATION_SETTING_KEY = exports.JEV_AUTO_BUDGET_SETTING_KEY = exports.POOL_AUTO_READ_MAX = exports.POOL_READ_MAX = exports.ICP_RERANK_DELAY_MS = exports.ICP_READ_RETRY_DELAY_MS = exports.ICP_READ_NEW_DELAY_MS = exports.ICP_READ_ATTEMPTS_MAX = exports.ICP_RANK_KEY_NEEDS_A_LOOK = exports.ICP_RANK_KEY_MUSTS_BONUS = exports.ICP_RANK_KEY_TAB_BASE = exports.ICP_MUST_MISSING_STARS_MAX = exports.ICP_STAR_FLOORS = void 0;
exports.icpPartTextOf = icpPartTextOf;
exports.jevPartNameOf = jevPartNameOf;
exports.jevPartNoteOf = jevPartNoteOf;
exports.icpFactTextOf = icpFactTextOf;
exports.icpAliasesOf = icpAliasesOf;
exports.isJevReadItem = isJevReadItem;
const zod_1 = require("zod");
const enums_1 = require("./enums");
const jev_1 = require("./jev");
const schemas_1 = require("./schemas");
// ADR 0061 — the ideal candidate profile (ICP) on RNK-01. HR builds it with Sonnet 5.5 (which never sees a CV and never
// ranks), rates each line 1–5, and Jev reads the CVs against its lines. The ratings are the weights; 5 is a must-have.
// The profile only re-orders (ADR 0049): the criteria's score, stars and tab stay official. Shared, so the browser and the
// server cut the same limits and speak the same words. docs/PLAN-jev-icp.md §3.3 and §4 are the spec of this file.
// Owner answers of 2026-10-25: years of experience is a RANGE (Q2 b) and "Can start within N days" is a fifth fact (Q5 a).
// ADR 0062 / docs/PLAN-icp-main-ranking.md: from there on the profile is every job's MAIN ranking (tabs, stars, order, Review,
// Shortlist, Contact), not only a third order on Ranking. The "ADR 0062" section at the end of this file is that contract.
// ---- Groups, ratings, sources ----
exports.ICP_GROUPS = ['skills', 'habits', 'communication', 'facts'];
exports.ICP_GROUP_LABELS = {
    skills: 'Skills and experience',
    habits: 'Work habits for this role',
    communication: 'Communication',
    facts: 'Hard facts',
};
exports.ICP_GROUP_HOW = {
    skills: 'Jev reads the CV',
    habits: 'Jev reads the CV · often unknown',
    communication: 'Jev’s English check',
    facts: 'Worked out from the application',
};
exports.ICP_RATINGS = [1, 2, 3, 4, 5];
/** The rating that makes a line a must-have: the ask's `isMust` is `rating === ICP_MUST_RATING` at ask time. */
exports.ICP_MUST_RATING = 5;
exports.ICP_RATING_LABELS = {
    1: 'Barely matters',
    2: 'Nice to have',
    3: 'Matters',
    4: 'Matters a lot',
    5: 'Must have',
};
/** "From the job" / "From your answer" / "Added by you". */
exports.ICP_SOURCES = ['job', 'answer', 'added'];
exports.ICP_SOURCE_LABELS = {
    job: 'From the job',
    answer: 'From your answer',
    added: 'Added by you',
};
// ---- Limits (PLAN §3.3) ----
/** Q3 (a): skills and habits lines together — the lines Jev reads. */
exports.ICP_JEV_ITEMS_MAX = 10;
/** One Communication line. */
exports.ICP_ENGLISH_MAX = 1;
exports.ICP_FACT_TYPES = ['years', 'education', 'location', 'salary', 'notice'];
exports.ICP_FACT_TYPE_LABELS = {
    years: 'Years of experience',
    education: 'Education',
    location: 'Where they live',
    salary: 'Expected salary',
    notice: 'Can start within',
};
/** 10 Jev lines + 1 English + one of each fact type (Q5 a made it five). */
exports.ICP_ITEMS_MAX = exports.ICP_JEV_ITEMS_MAX + exports.ICP_ENGLISH_MAX + exports.ICP_FACT_TYPES.length;
/** A part's text is title + evidence (≤ 260), built on the server, so the ad-hoc 200-character part limit does not apply. */
exports.ICP_TEXT_MAX = 90;
exports.ICP_EVIDENCE_MAX = 160;
exports.ICP_CITY_MAX = 60;
/** "Chattogram" plus "Chittagong", "CTG". */
exports.ICP_ALIASES_MAX = 5;
exports.ICP_YEARS_MAX = 40;
/** Q2 (b): a range, in half years. */
exports.ICP_YEARS_STEP = 0.5;
/** Q5 (a): the same ceiling the Candidates filter "Longest notice" uses. */
exports.ICP_NOTICE_DAYS_MAX = 365;
exports.ICP_QUESTIONS_MAX = 8;
exports.ICP_MORE_QUESTIONS_MAX = 4;
exports.ICP_QUESTION_MAX = 220;
exports.ICP_OPTIONS_MAX = 6;
exports.ICP_OPTION_MAX = 60;
exports.ICP_ANSWER_MAX = 500;
// Scoring thresholds (PLAN §3.3 and §5.2); A's functions read them.
/** Over the salary top by at most this many percent counts half. */
exports.ICP_SALARY_NEAR_PERCENT = 10;
/** Q2 (b): up to this many years under the minimum counts half. */
exports.ICP_YEARS_NEAR = 1;
/** Q2 (b): over the range's top counts this share of a full match. */
exports.ICP_YEARS_OVER_CREDIT = 0.5;
/** Q5 (a): notice up to this many times N counts half; within N is met. */
exports.ICP_NOTICE_NEAR_FACTOR = 2;
/** English at or above this level meets a must (nearer "a few small mistakes" than "several"). */
exports.ICP_ENGLISH_MEETS_AT = 1.5;
/** Power sorting writes at most once per burst of clicks this long (web). */
exports.ICP_RATINGS_SAVE_DELAY_MS = 600;
// Estimates shown before ranking.
// Why these numbers: the 2026-10-26 live check (scripts/icp-live-check.ts) ranked 323 real CVs on 10 lines and read
// 18,278 input tokens per CV (5,903,937 in all, 24.8¢); the old 2,500 + 10 x 1,300 = 15,500 said 21¢. That run gives one
// total, not a base and a per-line figure separately, so the split keeps the old 2,500 : 1,300 ratio and scales both by
// 18,278 / 15,500 (about 1.18): real CVs are longer than the invented ones the old numbers came from, so the CV and each
// line's questions (which carry the CV) both grow. 2,950 + 10 x 1,530 = 18,250 per CV, 0.2% under the live figure. Fewer
// lines are only as good as that ratio; re-measure with a 3-line ask if short asks matter.
exports.JEV_TOKENS_PER_CV_ESTIMATE = 2_950;
exports.JEV_TOKENS_PER_PART_ESTIMATE = 1_530;
/** Sonnet 5.5's list prices (2026-10): micro-USD per 1,000 tokens. */
exports.SONNET_MICRO_USD_PER_THOUSAND_INPUT = 2_000;
exports.SONNET_MICRO_USD_PER_THOUSAND_OUTPUT = 10_000;
exports.SONNET_MICRO_USD_PER_THOUSAND_CACHE_READ = 200;
exports.SONNET_MICRO_USD_PER_THOUSAND_CACHE_WRITE = 2_500;
/** The profile line Jev is asked about: the title, then what counts as evidence. */
function icpPartTextOf(item) {
    return item.evidence === '' ? item.text : `${item.text} — counts: ${item.evidence}`;
}
const PART_NOTE_SEPARATOR = ' — counts:';
/**
 * The short name of a line Jev read: the words before the "— counts: …" note `icpPartTextOf` adds. What a person reads uses this;
 * the joined text stays the key that readings, corrections and answers are matched on.
 */
function jevPartNameOf(text) {
    const at = text.indexOf(PART_NOTE_SEPARATOR);
    const name = (at < 0 ? text : text.slice(0, at)).trim();
    return name === '' ? text : name;
}
/** The "what counts as evidence" note after the name, or null when the line has none. */
function jevPartNoteOf(text) {
    const at = text.indexOf(PART_NOTE_SEPARATOR);
    if (at < 0)
        return null;
    const note = text.slice(at + PART_NOTE_SEPARATOR.length).trim();
    return note === '' ? null : note;
}
function yearsText(years) {
    return `${years} ${years === 1 ? 'year' : 'years'}`;
}
/** "At least 2 years of work experience" · "2–5 years of work experience" · "Bachelor's or higher" · "Lives in Chattogram" … */
function icpFactTextOf(fact) {
    switch (fact.type) {
        case 'years':
            if (fact.maxYears === null)
                return `At least ${yearsText(fact.minYears)} of work experience`;
            if (fact.maxYears === fact.minYears)
                return `${yearsText(fact.minYears)} of work experience`;
            return `${fact.minYears}–${yearsText(fact.maxYears)} of work experience`;
        case 'education':
            return `${enums_1.EDUCATION_LEVEL_LABELS[fact.minLevel]} or higher`;
        case 'location':
            return `Lives in ${fact.city}`;
        case 'salary':
            return "Expected salary within the job's budget";
        case 'notice':
            return fact.withinDays === 0 ? 'Can start immediately' : `Can start within ${fact.withinDays === 1 ? '1 day' : `${fact.withinDays} days`}`;
    }
}
function spellingKey(text) {
    return text.replace(/\s+/g, ' ').trim().toLowerCase();
}
/** The other spellings of a city: never the city itself, never a repeat, ignoring case and spacing. */
function icpAliasesOf(city, aliases) {
    const seen = new Set([spellingKey(city)]);
    return aliases.filter((alias) => {
        const key = spellingKey(alias);
        if (key === '' || seen.has(key))
            return false;
        seen.add(key);
        return true;
    });
}
/** The lines Jev reads: skills, habits and English (English is a per-CV check, not a part). */
function isJevReadItem(item) {
    return item.kind !== 'fact';
}
// ---- Input schemas ----
exports.icpRatingSchema = zod_1.z.union([zod_1.z.literal(1), zod_1.z.literal(2), zod_1.z.literal(3), zod_1.z.literal(4), zod_1.z.literal(5)], { error: 'Rate it from 1 to 5.' });
const yearsBoundSchema = zod_1.z.number().min(0).max(exports.ICP_YEARS_MAX, `At most ${exports.ICP_YEARS_MAX} years.`).multipleOf(exports.ICP_YEARS_STEP, 'Whole or half years only.');
const lineTextSchema = zod_1.z.string().trim().min(jev_1.JEV_PART_MIN_LENGTH, 'Give it a short title.').max(exports.ICP_TEXT_MAX, `Keep the title under ${exports.ICP_TEXT_MAX} characters.`);
const evidenceSchema = zod_1.z.string().trim().max(exports.ICP_EVIDENCE_MAX, `Keep this under ${exports.ICP_EVIDENCE_MAX} characters.`).default('');
const cityTextSchema = zod_1.z.string().trim().min(1, 'Name the city.').max(exports.ICP_CITY_MAX, `Keep it under ${exports.ICP_CITY_MAX} characters.`);
exports.icpFactSchema = zod_1.z.discriminatedUnion('type', [
    zod_1.z
        .object({ type: zod_1.z.literal('years'), minYears: yearsBoundSchema, maxYears: yearsBoundSchema.nullable().default(null) })
        .superRefine((fact, ctx) => {
        if (fact.maxYears !== null && fact.maxYears < fact.minYears)
            ctx.addIssue({ code: 'custom', path: ['maxYears'], message: "The top can't be under the minimum." });
        if (fact.maxYears === null && fact.minYears === 0)
            ctx.addIssue({ code: 'custom', path: ['minYears'], message: 'Set a minimum or a top.' });
    }),
    zod_1.z.object({ type: zod_1.z.literal('education'), minLevel: zod_1.z.enum(enums_1.EDUCATION_LEVELS) }),
    zod_1.z
        .object({ type: zod_1.z.literal('location'), city: cityTextSchema, aliases: zod_1.z.array(cityTextSchema).max(exports.ICP_ALIASES_MAX, `At most ${exports.ICP_ALIASES_MAX} other spellings.`).default([]) })
        .transform((fact) => ({ ...fact, aliases: [...icpAliasesOf(fact.city, fact.aliases)] })),
    zod_1.z.object({ type: zod_1.z.literal('salary') }),
    zod_1.z.object({ type: zod_1.z.literal('notice'), withinDays: zod_1.z.number().int('Whole days only.').min(0).max(exports.ICP_NOTICE_DAYS_MAX, `At most ${exports.ICP_NOTICE_DAYS_MAX} days.`) }),
]);
const itemBase = { id: schemas_1.uuidSchema, rating: exports.icpRatingSchema, source: zod_1.z.enum(exports.ICP_SOURCES) };
/** One line as the browser sends it. Fact lines take no text (the app writes it); every id is a uuid made in the browser. */
exports.icpItemInputSchema = zod_1.z.discriminatedUnion('kind', [
    zod_1.z.object({ ...itemBase, kind: zod_1.z.literal('jev'), group: zod_1.z.enum(['skills', 'habits']), text: lineTextSchema, evidence: evidenceSchema }),
    zod_1.z.object({ ...itemBase, kind: zod_1.z.literal('english'), group: zod_1.z.literal('communication'), text: lineTextSchema, evidence: evidenceSchema }),
    zod_1.z.object({ ...itemBase, kind: zod_1.z.literal('fact'), group: zod_1.z.literal('facts'), fact: exports.icpFactSchema }),
]);
/** Every typed word on a line: what Jev, Sonnet and the recruiter's reader may not be asked to weigh (ADR 0050 §6). */
function typedWordsOf(item) {
    if (item.kind !== 'fact')
        return [{ path: ['text'], text: item.text }, { path: ['evidence'], text: item.evidence }];
    if (item.fact.type !== 'location')
        return [];
    return [{ path: ['fact', 'city'], text: item.fact.city }, ...item.fact.aliases.map((alias, index) => ({ path: ['fact', 'aliases', index], text: alias }))];
}
function checkIcpItems(items, ctx, at) {
    const ids = new Set();
    const factTypes = new Set();
    let jevLines = 0;
    let englishLines = 0;
    items.forEach((item, index) => {
        if (ids.has(item.id))
            ctx.addIssue({ code: 'custom', path: [...at, index, 'id'], message: 'Two lines share one id.' });
        ids.add(item.id);
        if (item.kind === 'jev')
            jevLines += 1;
        if (item.kind === 'english')
            englishLines += 1;
        if (item.kind === 'fact') {
            if (factTypes.has(item.fact.type))
                ctx.addIssue({ code: 'custom', path: [...at, index, 'fact'], message: 'Each kind of fact can be added once.' });
            factTypes.add(item.fact.type);
        }
        for (const { path, text } of typedWordsOf(item)) {
            const kind = (0, jev_1.unfairAskKind)(text);
            if (kind)
                ctx.addIssue({ code: 'custom', path: [...at, index, ...path], message: jev_1.UNFAIR_ASK_TITLES[kind] });
        }
    });
    if (jevLines > exports.ICP_JEV_ITEMS_MAX)
        ctx.addIssue({ code: 'custom', path: [...at], message: `Jev reads up to ${exports.ICP_JEV_ITEMS_MAX} lines. Remove ${jevLines - exports.ICP_JEV_ITEMS_MAX}.` });
    if (englishLines > exports.ICP_ENGLISH_MAX)
        ctx.addIssue({ code: 'custom', path: [...at], message: 'Only one English line.' });
}
exports.saveIcpSchema = zod_1.z
    .object({
    /** The profile's content version; null only when creating. */
    version: zod_1.z.number().int().positive().nullable(),
    items: zod_1.z.array(exports.icpItemInputSchema).min(1, 'Add at least one line.').max(exports.ICP_ITEMS_MAX),
    /** The interview this profile came from, kept in the event for the audit trail. */
    interviewId: schemas_1.uuidSchema.nullable().default(null),
    /** Rank with Jev now, when the profile has something new for it to read. */
    rank: zod_1.z.boolean(),
})
    .superRefine((input, ctx) => checkIcpItems(input.items, ctx, ['items']));
/** Power sorting: the new focus for some lines, or back to the ratings last saved in the form. */
exports.setIcpRatingsSchema = zod_1.z.union([
    zod_1.z.object({ ratings: zod_1.z.record(schemas_1.uuidSchema, exports.icpRatingSchema).refine((ratings) => Object.keys(ratings).length > 0, 'Change at least one rating.') }),
    zod_1.z.object({ reset: zod_1.z.literal(true) }),
]);
exports.startIcpInterviewSchema = zod_1.z.object({
    mode: zod_1.z.enum(['new', 'more']),
    /** "Ask me more questions" starts from the form's lines. */
    items: zod_1.z.array(exports.icpItemInputSchema).max(exports.ICP_ITEMS_MAX).default([]),
});
exports.ICP_UNFAIR_ANSWER = 'That answer is about who a person is. Say what the work needs instead.';
exports.ICP_EMPTY_ANSWER = 'Pick an option, type an answer, or skip.';
exports.answerIcpQuestionSchema = zod_1.z
    .object({
    /** The index of the open question: a double submit is refused. */
    turn: zod_1.z.number().int().min(0),
    choices: zod_1.z.array(zod_1.z.string().trim().min(1).max(exports.ICP_OPTION_MAX)).max(exports.ICP_OPTIONS_MAX).default([]),
    text: zod_1.z.string().trim().max(exports.ICP_ANSWER_MAX).nullable().default(null),
    isSkipped: zod_1.z.boolean().default(false),
})
    .superRefine((answer, ctx) => {
    if (!answer.isSkipped && answer.choices.length === 0 && (answer.text === null || answer.text === '')) {
        ctx.addIssue({ code: 'custom', path: ['text'], message: exports.ICP_EMPTY_ANSWER });
    }
    if (answer.text !== null && (0, jev_1.unfairAskKind)(answer.text))
        ctx.addIssue({ code: 'custom', path: ['text'], message: exports.ICP_UNFAIR_ANSWER });
});
exports.ICP_EVENTS = {
    PROFILE_SAVED: 'icp.profile_saved',
    FOCUS_CHANGED: 'icp.focus_changed',
    INTERVIEW_STARTED: 'icp.interview_started',
    QUESTION_ASKED: 'icp.question_asked',
    INTERVIEW_ANSWERED: 'icp.interview_answered',
    PROFILE_DRAFTED: 'icp.profile_drafted',
};
/** §2.4: Top fit needs no unmet must-have and a match from here. */
exports.ICP_TOP_FIT_MATCH = 75;
/** §2.4: Maybe is not Top fit and a match from here; under it is Low fit. */
exports.ICP_MAYBE_MATCH = 50;
/** §2.4: the first floor a match reaches decides the stars, best first. */
exports.ICP_STAR_FLOORS = [
    { stars: 5, from: 90 },
    { stars: 4, from: 75 },
    { stars: 3, from: 50 },
    { stars: 2, from: 25 },
    { stars: 1, from: 0 },
];
/** §2.4: a person missing a must-have never shows more than this many stars. */
exports.ICP_MUST_MISSING_STARS_MAX = 3;
/** §2.4: `rank_key` = tab base + (no unmet must-have ? bonus : 0) + match. Needs a look is `ICP_RANK_KEY_NEEDS_A_LOOK`; Waiting is null. */
exports.ICP_RANK_KEY_TAB_BASE = { top_fit: 3_000, maybe: 2_000, low_fit: 1_000 };
exports.ICP_RANK_KEY_MUSTS_BONUS = 200;
exports.ICP_RANK_KEY_NEEDS_A_LOOK = 0;
/** §2.6: a person Jev failed on this many times goes to Needs a look. */
exports.ICP_READ_ATTEMPTS_MAX = 3;
/** §2.6: an import's trickle of applications becomes one read this long after the last one. */
exports.ICP_READ_NEW_DELAY_MS = 20_000;
/** §2.6: a failed person is retried by the next top-up, queued this long after. */
exports.ICP_READ_RETRY_DELAY_MS = 300_000;
/** §2.5: a Focus-bar change re-ranks the whole job this long after the last click. */
exports.ICP_RERANK_DELAY_MS = 3_000;
/** §5: people read per press of "Read their CVs with Jev", and on job open. */
exports.POOL_READ_MAX = 200;
exports.POOL_AUTO_READ_MAX = 100;
/** `system_settings` keys (§2.6, §6.2). */
exports.JEV_AUTO_BUDGET_SETTING_KEY = 'jev_auto_budget';
exports.RANKING_MIGRATION_SETTING_KEY = 'ranking_migration';
/** OQ3 (a): $10 a day of automatic reading; $25 for the one-off move, both in millionths of a dollar. */
exports.JEV_AUTO_BUDGET_DEFAULT_MICRO_USD = 10_000_000;
exports.RANKING_MIGRATION_BUDGET_DEFAULT_MICRO_USD = 25_000_000;
/** §6.2: jobs read at once by the move, and how often a failed one is retried (after the delay). */
exports.RANKING_MIGRATION_JOBS_AT_ONCE = 2;
exports.RANKING_MIGRATION_RETRIES_MAX = 3;
exports.RANKING_MIGRATION_RETRY_DELAY_MS = 1_800_000;
/**
 * §2.3. `read`: Jev read the CV. `waiting`: not read yet (no tab; counted as "Jev is reading N new CVs"). `unreadable`: no CV,
 * a scan, or three failed reads (Needs a look). `not_connected`: readable CV but no Jev key (ranked on facts). `not_needed`: the
 * profile has no Jev-read line, so nothing waits for Jev.
 */
exports.ICP_READ_STATES = ['read', 'waiting', 'unreadable', 'not_connected', 'not_needed'];
/** One job's place in the move to the profile (ADMIN-17's card, §6.2). */
exports.RANKING_MIGRATION_STATUSES = ['moved', 'reading', 'waiting_for_budget', 'failed', 'closed_not_read'];
exports.raiseRankingMigrationBudgetSchema = zod_1.z.object({
    /** In millionths of a dollar; it can only be raised. */
    approvedMicroUsd: zod_1.z.number().int().positive().max(1_000_000_000_000),
});
exports.setJevAutoBudgetSchema = zod_1.z.object({
    dailyMicroUsd: zod_1.z.number().int().min(0).max(1_000_000_000_000),
});
/** A job's profile inside a template or a job config (§4): lines only. The ratings are the baseline (a template clones; ids are made new on apply). */
exports.icpConfigProfileSchema = zod_1.z
    .object({ items: zod_1.z.array(exports.icpItemInputSchema).min(1, 'Add at least one line.').max(exports.ICP_ITEMS_MAX) })
    .superRefine((profile, ctx) => checkIcpItems(profile.items, ctx, ['items']));
/** The new events of §2.10, beside `ICP_EVENTS`. */
exports.PROFILE_RANKING_EVENTS = {
    /** A job moved from the criteria to the profile as its main ranking. */
    RANKING_MOVED_TO_PROFILE: 'job.ranking_moved_to_profile',
    /** One press of "Read their CVs with Jev" on a pool match, or the automatic read on job open. */
    POOL_MATCH_READ: 'pool.match_read',
};
//# sourceMappingURL=icp.js.map